export const siteSettings = {
  name: "LumeX Pro",
  link: "https://LumeXPro.net",
  email: "support@LumeXPro.net",
  appLink: "https://app.LumeXPro.net",
};
